import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { UserPlus, CheckCircle, XCircle, Clock, FileText, TrendingUp, Calculator, Play, Eye } from 'lucide-react';

export default function GestionMembresCooperModals({ ctx }) {
  const { coopers, handleBulkAssign, handleCreateNewSimulation, handleFinalizeSimulation, handleResumeSimulation, loadingSimulations, membreSimulations, _membres, selectedCooper, selectedIds, selectedMembreForSimulation, showAssignModal, showSimulationsModal, setSelectedCooper, setShowAssignModal, setSelectedMembreForSimulation, setMembreSimulations, setShowSimulationsModal } = ctx;
  return (
    <>
      {/* Modal d'assignation — ultra pro */}
      {showAssignModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
          <Card className="w-full max-w-2xl border-0 shadow-2xl overflow-hidden">
            <div className="bg-gradient-to-r from-emerald-500 via-green-500 to-teal-500 text-white px-6 py-5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center flex-shrink-0">
                  <UserPlus className="h-5 w-5 text-white" />
                </div>
                <div>
                  <h2 className="text-lg font-bold leading-tight">Assigner à un COOPER&apos;S</h2>
                  <p className="text-sm text-white/85 mt-0.5">
                    {selectedIds.length} membre{selectedIds.length > 1 ? 's' : ''} sélectionné{selectedIds.length > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
            </div>
            <CardContent className="space-y-4 p-6">
              <div>
                <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
                  Sélectionner un COOPER&apos;S
                </label>
                <select
                  value={selectedCooper}
                  onChange={(e) => setSelectedCooper(e.target.value)}
                  className="w-full px-4 py-2.5 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-white"
                >
                  <option value="">— Sélectionner un COOPER&apos;S —</option>
                  {coopers.map(cooper => (
                    <option key={cooper.id} value={cooper.id}>
                      {cooper.prenom} {cooper.nom} — {cooper.capacite.membres_assignes} membres ({cooper.capacite.dossiers_en_cours} dossiers en cours)
                    </option>
                  ))}
                </select>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-3 flex items-start gap-2">
                <div className="w-7 h-7 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <TrendingUp className="h-3.5 w-3.5 text-white" />
                </div>
                <p className="text-xs text-blue-900 leading-relaxed">
                  <strong>Optimisation auto</strong> — Les COOPER&apos;S sont triés par charge de travail (du moins chargé au plus chargé) pour équilibrer la répartition.
                </p>
              </div>

              <div className="flex gap-2 justify-end pt-3 border-t">
                <Button
                  onClick={() => {
                    setShowAssignModal(false);
                    setSelectedCooper('');
                  }}
                  variant="outline"
                  className="border-slate-300"
                >
                  Annuler
                </Button>
                <Button
                  onClick={handleBulkAssign}
                  className="bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white shadow-md gap-2"
                  disabled={!selectedCooper}
                >
                  <UserPlus className="h-4 w-4" />
                  Confirmer l&apos;assignation
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Modal Simulations BATICO */}
      {showSimulationsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <Card className="w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <CardHeader className="bg-gradient-to-r from-amber-500 to-orange-500 text-white">
              <CardTitle className="flex items-center gap-2">
                <Calculator className="h-6 w-6" />
                Simulations RCDS BATICO
              </CardTitle>
              {selectedMembreForSimulation && (
                <p className="text-amber-100">
                  {selectedMembreForSimulation.raison_sociale || selectedMembreForSimulation.entreprise} - {selectedMembreForSimulation.siret}
                </p>
              )}
            </CardHeader>
            <CardContent className="p-6 overflow-y-auto max-h-[calc(90vh-150px)]">
              {loadingSimulations ? (
                <div className="flex items-center justify-center py-12">
                  <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : membreSimulations ? (
                <div className="space-y-6">
                  {/* Simulations en cours */}
                  <div>
                    <h3 className="text-lg font-bold text-amber-800 mb-3 flex items-center gap-2">
                      <Clock className="h-5 w-5" />
                      Simulations en cours ({membreSimulations.simulations_en_cours?.length || 0})
                    </h3>
                    {membreSimulations.simulations_en_cours?.length > 0 ? (
                      <div className="grid gap-3">
                        {membreSimulations.simulations_en_cours.map(sim => (
                          <div 
                            key={sim.id} 
                            className="border-2 border-amber-200 rounded-xl p-4 bg-amber-50 hover:bg-amber-100 transition-colors"
                          >
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-2">
                                  <Badge className="bg-amber-600 text-white font-semibold">
                                    {sim.type_calculateur || 'BATICO'}
                                  </Badge>
                                  <Badge className="bg-blue-600 text-white font-semibold">
                                    {sim.type_adhesion === 'nominative' ? 'Nominative' : 'Globale'}
                                  </Badge>
                                  <Badge className="bg-slate-500 text-white font-semibold">
                                    Étape {sim.etape_courante || 1}
                                  </Badge>
                                  {sim.modified_by_admin && (
                                    <Badge className="bg-purple-600 text-white font-semibold">
                                      Modifié par Admin
                                    </Badge>
                                  )}
                                </div>
                                <p className="text-sm text-slate-600 mb-1">
                                  <strong>Territoire:</strong> {sim.territoire || 'Non défini'}
                                </p>
                                {sim.chiffre_affaires && (
                                  <p className="text-sm text-slate-600 mb-1">
                                    <strong>CA (Montant de base) :</strong> {Number(sim.chiffre_affaires).toLocaleString('fr-FR')} €
                                  </p>
                                )}
                                {sim.montant_total_ttc && (
                                  <p className="text-sm text-slate-600 mb-1">
                                    <strong>Montant Global :</strong> {Number(sim.montant_total_ttc).toLocaleString('fr-FR')} €
                                  </p>
                                )}
                                {sim.activites?.length > 0 && (
                                  <p className="text-sm text-slate-600 mb-1">
                                    <strong>Activités:</strong> {sim.activites.length} sélectionnée(s)
                                  </p>
                                )}
                                <p className="text-xs text-slate-400 mt-2">
                                  Créée le {new Date(sim.created_at).toLocaleDateString('fr-FR')}
                                  {sim.admin_modified_at && (
                                    <span className="ml-2 text-purple-600">
                                      • Modifié le {new Date(sim.admin_modified_at).toLocaleDateString('fr-FR')}
                                    </span>
                                  )}
                                </p>
                              </div>
                              <div className="flex flex-col gap-2">
                                <Button
                                  onClick={() => handleResumeSimulation(sim)}
                                  className="bg-amber-600 hover:bg-amber-700 text-white gap-2"
                                  data-testid={`resume-simulation-${sim.id}`}
                                >
                                  <Play className="h-4 w-4" />
                                  Modifier
                                </Button>
                                <Button
                                  onClick={() => handleFinalizeSimulation(sim)}
                                  className="bg-green-600 hover:bg-green-700 text-white gap-2"
                                  data-testid={`finalize-simulation-${sim.id}`}
                                >
                                  <CheckCircle className="h-4 w-4" />
                                  Finaliser
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-6 bg-slate-50 rounded-xl">
                        <Clock className="h-10 w-10 mx-auto text-slate-300 mb-2" />
                        <p className="text-slate-500">Aucune simulation en cours</p>
                      </div>
                    )}
                  </div>

                  {/* Simulations terminées */}
                  <div>
                    <h3 className="text-lg font-bold text-green-800 mb-3 flex items-center gap-2">
                      <CheckCircle className="h-5 w-5" />
                      Simulations terminées ({membreSimulations.simulations_terminees?.length || 0})
                    </h3>
                    {membreSimulations.simulations_terminees?.length > 0 ? (
                      <div className="grid gap-3">
                        {membreSimulations.simulations_terminees.slice(0, 5).map(sim => (
                          <div 
                            key={sim.id} 
                            className="border border-green-200 rounded-xl p-4 bg-green-50"
                          >
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-2">
                                  <Badge className="bg-green-600 text-white font-semibold">
                                    {sim.type_calculateur || 'BATICO'}
                                  </Badge>
                                  <Badge className="bg-green-700 text-white font-semibold">
                                    {sim.statut}
                                  </Badge>
                                  {sim.is_paid && (
                                    <Badge className="bg-emerald-600 text-white font-semibold">Payé</Badge>
                                  )}
                                </div>
                                {sim.montant_total_ttc && (
                                  <p className="text-sm text-slate-600">
                                    <strong>Montant Global :</strong> {Number(sim.montant_total_ttc).toLocaleString('fr-FR')} €
                                  </p>
                                )}
                                <p className="text-xs text-slate-400 mt-2">
                                  {new Date(sim.created_at).toLocaleDateString('fr-FR')}
                                </p>
                              </div>
                              <Button
                                onClick={() => handleResumeSimulation(sim)}
                                variant="outline"
                                size="sm"
                                className="gap-1"
                              >
                                <Eye className="h-4 w-4" />
                                Voir
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-6 bg-slate-50 rounded-xl">
                        <FileText className="h-10 w-10 mx-auto text-slate-300 mb-2" />
                        <p className="text-slate-500">Aucune simulation terminée</p>
                      </div>
                    )}
                  </div>

                  {/* Actions */}
                  <div className="pt-4 border-t flex justify-between">
                    <Button
                      onClick={() => handleCreateNewSimulation(selectedMembreForSimulation)}
                      className="bg-green-600 hover:bg-green-700 text-white gap-2"
                    >
                      <Play className="h-4 w-4" />
                      Nouvelle simulation BATICO
                    </Button>
                    <Button
                      onClick={() => {
                        setShowSimulationsModal(false);
                        setSelectedMembreForSimulation(null);
                        setMembreSimulations(null);
                      }}
                      variant="outline"
                    >
                      Fermer
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="text-center py-12">
                  <XCircle className="h-12 w-12 mx-auto text-red-400 mb-3" />
                  <p className="text-slate-600">Erreur lors du chargement des simulations</p>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
}
